export default {
  title: 'Meri Bachat',
  language: ['Language', 'English', 'Hindi'],
  dropdown: [
    'Home',
    'About Us',
    'Support Us',
    'Terms and Conditions',
    'Privacy Policy'
  ],
  location: 'Lucknow',
  login: 'Login',
  logout: 'Logout',
  search: 'Search',
  categories: [
    {
      field: 'accessories',
      accessories: 'Accessories',
      subCategories: {
        kids: 'Kids',
        men: 'Men',
        women: 'Women'
      },
      index: 0
    },
    {
      field: 'apparels',
      apparels: 'Apparels',
      subCategories: {
        kids: 'Kids',
        men: 'Men',
        women: 'Women'
      },
      index: 1
    },
    {
      field: 'electronics',
      electronics: 'Electronics',
      subCategories: {
        gadgets: 'Gadgets'
      },
      index: 2
    },
    {
      field: 'entertainment',
      entertainment: 'Entertainment',
      subCategories: {
        gaming: 'Gaming',
        movies: 'Movies',
        music: 'Music',
        ott: 'OTT'
      },
      index: 3
    },
    {
      field: 'food',
      food: 'Food',
      subCategories: {
        cafe: 'Cafe',
        restaurant: 'Restaurant',
        pizza: 'Pizza',
        'fast-food': 'Fast Food',
        membership: 'Membership',
        'home-delivery': 'Home Delivery',
        desserts: 'Desserts'
      },
      index: 4
    },
    {
      field: 'stationery',
      stationery: 'Stationery',
      subCategories: {
        magazine: 'Magazine',
        'book-store': 'Book Store'
      },
      index: 5
    }
  ],
  groupCategory: [
    {
      title: 'Portals',
      category: {
        ecommerce: 'E-Commerce',
        grocery: 'Grocery',
        'beauty-wellness': 'Beauty & Wellness'
      },
      index: 6
    },
    {
      title: 'Others',
      category: {
        'traver-stay': 'Travel/Stay',
        'home-decor': 'Home Decor',
        jewellery: 'Jewellery',
        medicine: 'Medicine'
      },
      index: 7
    }
  ],
  locationMenu: {
    title: 'Pick a City',
    subTitle: 'To find awesome offers around you',
    searchText: 'Enter your city name',
    searchButton: 'Use My Current Location',
    closeButton: 'Close',
    recommendation: [
      'Top Cities',
      'New Delhi',
      'Gurgaon',
      'Jaipur',
      'Bangalore',
      'Mumbai',
      'Kolkata',
      'Hyderabad',
      'Chennai',
      'Chandigarh',
      'Pune',
      'Ahmedabad',
      'Goa'
    ]
  }
}
